import { SxProps, Theme } from "@mui/material/styles";
import CoreBadge from "./CoreBadge";
import DiscontinuedBadge from "./DiscontinuedBadge";
import KviBadge from "./KviBadge";

export const BADGE_IDS = {
    CORE: "CORE",
    KVI: "KVI",
    DISCONTINUED: "DISCONTINUED"
} as const;

export type BadgeId = (typeof BADGE_IDS)[keyof typeof BADGE_IDS];

const badgeMapper: Record<BadgeId, React.FC<{ sx?: SxProps<Theme> }>> = {
    [BADGE_IDS.CORE]: CoreBadge,
    [BADGE_IDS.KVI]: KviBadge,
    [BADGE_IDS.DISCONTINUED]: DiscontinuedBadge
};

export default badgeMapper;
